
export class roleMSDTO{
  id: number;
  description: string;
}

export class roleMS extends roleMSDTO{
  applicationId?: number = -1;
  application: string;
  ms_base_url: string;
}

export class UserRoleMS {
  user_id: number;
  ms_base_url: string;
}



// WEBPACK FOOTER //
// ./src/app/models/roleMS.model.ts